import { FileTextIcon, ZapIcon, ActivityIcon, SmartphoneIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% PDF Visivo'
}, {
  icon: ZapIcon,
  label: 'Download Immediato'
}, {
  icon: ActivityIcon,
  label: 'Tutti i livelli'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export const stats = [{
  value: '500+',
  label: 'Professionisti soddisfatti'
}, {
  value: '6+5',
  label: 'Volumi + Bonus'
}, {
  value: '99%',
  label: 'Lo raccomandano'
}, {
  value: '4.9/5',
  label: '⭐ Valutazione globale'
}];
